import { render } from "./BaseDialogDeleteConfirmation.vue?vue&type=template&id=4978917f"
import script from "./BaseDialogDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./BaseDialogDeleteConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__